import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Analisis/peticionDataSwine`, method: 'POST', body: values, token: token})
}
